import { Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, Input, InputLabel, ListItemText, makeStyles, MenuItem, OutlinedInput, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core'

import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { FaFileExcel } from 'react-icons/fa'
import { MdClose, MdPrint } from 'react-icons/md'
import { useReactToPrint } from 'react-to-print'
import * as XLSX from 'xlsx'
import FunkyInput from './FunkyInput'
// import FunkyDate from '../../components/FunkyDate'

const getSuprafata = arr => arr?.reduce( (acc,el)=> acc+=el.terenHa, 0)?.toFixed(2)

const useStyles = makeStyles(theme => ({
            dialogPaper: {
                minHeight: "99vh", minWidth: "75vw"
            },
            tableContainer: {
                "@media screen" : {
                    maxHeight:"80vh"
                } 
            },
            table: {
                border: `1px solid ${theme.palette.grey[300]}`,
                '& th': { // Styles for TableCell components within a TableHead
                    backgroundColor: theme.palette.grey[200],
                    color: theme.palette.common.black,
                    fontWeight: 'bold',
                    border: `1px solid ${theme.palette.grey[300]}`,
                    lineHeight:'1.25em'
                },
                '& td': { // Styles for TableCell components within a TableBody
                    border: `1px solid ${theme.palette.grey[300]}`,
                    fontSize: '0.8em', // Increased font size for better readability
                    lineHeight:'1.25em',
                }
            },
            '@global': {
                '@media print': {
                    '@page': {
                        size: 'landscape',
                        margin: '1cm',
                      },
                      body: {
                        paddingTop: '20px',
                      },
                    'body, html': {
                        background: '#fff',
                        color: '#000',
                    },
                    '.printable-header': {
                        fontSize: '0.7rem !important',
                        padding: '4px 6px !important',
                    },
                    '.printable-cell': {
                        fontSize: '0.65rem !important',
                        padding: '2px 4px !important',
                        // Break long strings that have no spaces
                        wordBreak: 'break-all',
                    }
                }
            }
        }))

export default function RegistrAtestateuPrintModal({data, onClose}) {

    const classes = useStyles()
    const [items, setItems] = useState(null)

    const printRef = useRef()

    const [filteredItems, setFilteredItems] = useState(null)
    const [docTypes, setDocTypes] = useState([])
    const [filters, setFilters] = useState({ start: moment().startOf("year").format("YYYY-MM-DD"), end: moment().format("YYYY-MM-DD"), tip: [] })

    useEffect(()=>{  
        if (data) {
            setItems(data)
            const types = [...new Set(data.map(item => item.tip))];
            setDocTypes(types);
        }
    }, [data, onClose])

    useEffect(() => {
        if (!items) return;

        let newFilteredItems = items.filter(item => {
            const itemDate = moment(item.dt);
            const isAfterStart = filters.start ? itemDate.isSameOrAfter(filters.start, 'day') : true;
            const isBeforeEnd = filters.end ? itemDate.isSameOrBefore(filters.end, 'day') : true;
            const isCorrectType = filters.tip.length > 0 ? filters.tip.includes(item.tip) : true;
            return isAfterStart && isBeforeEnd && isCorrectType;
        });

        setFilteredItems(newFilteredItems);
    }, [filters, items]);

    const handleFilterChange = (name) => (event) => {
        const value = event.target.value;
        setFilters(prev => ({ ...prev, [name]: value ? moment(value).format("YYYY-MM-DD") : null }));
    };
    const handleSelectFilterChange = (event) => {
        const { target: { value } } = event;
        // On autofill we get a stringified value.
        setFilters(prev => ({ ...prev, tip: typeof value === 'string' ? value.split(',') : value }));
    };

        const printHandler = useReactToPrint({
            content: () => printRef.current,
            pageStyle: `
              @page {
                size: landscape;
                margin: 1cm;
              }
            `,
        });

        const intervalHandler = name => () => {
            switch (name) {
                case "cur-year": 
                    setFilters(prev => ({ 
                        ...prev, 
                        start:  moment().startOf("year").format("YYYY-MM-DD"),
                        end:  moment().endOf("year").format("YYYY-MM-DD"),
                    }));
                    break;
                case "prev-year": 
                    setFilters(prev => ({ 
                        ...prev, 
                        start:  moment().subtract(1, "year").startOf("year").format("YYYY-MM-DD"),
                        end:  moment().subtract(1, "year").endOf("year").format("YYYY-MM-DD"),
                    }));
                    break;
            }
        }
    const excelExportHandler = () => {
        if (!filteredItems) return;

        const rows = filteredItems.map((e, i) => ({
            'Nr.crt': i + 1,
            'Tip document': e.tipDocument,
            'Nr./Data': `${e.nr} / ${e?.human?.from}`,
            'Expiră la': e?.human?.to,
            'Perioadă rămasă': e?.human?.diff,
            'Arendator(i)': e.human.arendator,
            'Arendaș(i)': e.human.arendas,
            'Suprafata': getSuprafata(e.arendaTeren),
            'Preț': e.price
        }));

        const worksheet = XLSX.utils.json_to_sheet(rows);

        worksheet['!cols'] = [
            { wch: 8 },   // Nr.crt
            { wch: 15 },  // Tip document
            { wch: 20 },  // Nr./Data
            { wch: 15 },  // Expiră la
            { wch: 25 },  // Perioadă rămasă
            { wch: 35 },  // Arendator(i)
            { wch: 35 },  // Arendaș(i)
            { wch: 10 },  // Suprafata (ha)
            { wch: 10 }   // Preț
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "RegistruArendare");
        XLSX.writeFile(workbook, "RegistruArendare.xlsx");
    }

  return (
    <Dialog open = {Boolean(items)} onClose={()=>onClose()} 
    PaperProps={{style: {padding:"10px", minWidth:"80vw", minHeight:"100vh"}}}
    >
        <DialogTitle>
            <Grid container justifyContent="space-between">
                TIPĂRIRE REGISTRU ARENDARE
                <IconButton onClick={()=>onClose()}><MdClose/></IconButton>
              
            </Grid>

            </DialogTitle>
        <DialogContent>
            <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs = {2}>
                        <FunkyInput
                        type="date"

                            label="De la"
                            value={moment(filters.start).format("YYYY-MM-DD")}
                            onChange={handleFilterChange('start')}
                        />
                    </Grid>
                    <Grid item xs = {2}>
                        <FunkyInput type ="date"
                            label="Până la"
                            value={moment(filters.end).format("YYYY-MM-DD")}
                            onChange={handleFilterChange('end')}
                        />
                    </Grid>
                    <Grid item>
                        <Typography variant = "caption">Tip document</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <FormControl fullWidth size="small">
                            {/* <InputLabel>Tip Document</InputLabel> */}
                            <Select
                                multiple
                                
                                value={filters.tip || []}
                                onChange={handleSelectFilterChange}
                                input={<OutlinedInput label="Tip Document"/>}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => <Chip key={value} label={value} size="small" />)}
                                    </Box>
                                )}
                            >
                                {docTypes.map(type => <MenuItem key={type} value={type}>
                                    <Checkbox checked={filters.tip.indexOf(type) > -1} />
                                    <ListItemText primary={type} />
                                </MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <Button variant="outlined" onClick = {intervalHandler("cur-year")}>ANUL CURENT</Button>
                    </Grid>
                     <Grid item>
                        <Button variant="outlined" onClick = {intervalHandler("prev-year")}>ANUL ANTERIOR</Button>
                    </Grid>
                </Grid>
            </Box>
            {filteredItems && (
                <Box ref = {printRef}>
                    <TableContainer className={classes.tableContainer}>
                <Table stickyHeader className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nr.crt</TableCell>
                            <TableCell>Tip document</TableCell>
                            <TableCell>Nr./Data</TableCell>
                            <TableCell>Expiră la</TableCell>
                            <TableCell>Periadă rămasă</TableCell>
                            <TableCell>Arendator(i)</TableCell>
                            <TableCell>Arendaș(i)</TableCell>
                            <TableCell>Supr.(ha)</TableCell>
                            <TableCell>Preț</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredItems?.map((e,i)=> (
                            <TableRow key={`row-${i}`}>
                                <TableCell>{i+1}</TableCell>
                                <TableCell>{e.tipDocument}</TableCell>
                                <TableCell>{e.nr} / {e?.human?.from}</TableCell>
                                <TableCell>{e?.human?.to}</TableCell>
                                <TableCell>{e?.human?.diff}</TableCell>
                                <TableCell style = {{width:"200px"}}>
                                    <Box sx = {{wordWrap: "auto", whiteSpace:"auto"}}>
                                    {/* {e.arendaArendator?.reduce( (acc,el, ix)=> {
                                        acc += el?.contact?.name 
                                        if (ix < e.arendaArendator.length-1  ) { acc += `, `}
                                        return acc
                                    }
                                    , "")
                                     } */}
                                     {e.arendaArendator.map( (a, ix) => (
                                        <p style = {{lineHeight:1.25, padding:0, margin:0}} key ={ix}>{a?.contact?.name}
                                        {ix < e.arendaArendator.length-1 ? ", ": ""}
                                        </p>
                                     ))}
                                     </Box>
                                </TableCell>
                                <TableCell style = {{width:"200px"}}>
                                    <Box sx = {{wordWrap: "auto", whiteSpace:"auto"}}>
                                    {e.arendaArendas?.reduce( (acc,el, ix)=> {
                                        acc += el?.contact?.name 
                                        if (ix < e.arendaArendas.length-1  ) { acc += ", "}
                                        return acc
                                    }
                                    , "")
                                     }
                                     </Box>
                                </TableCell>
                                <TableCell>{getSuprafata(e.arendaTeren)}</TableCell>
                                <TableCell>{e.price}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                </TableContainer>
                </Box>
            )}



        </DialogContent>
        <DialogActions>
            <Button onClick={excelExportHandler} size="large"  color="success" startIcon={<FaFileExcel />}>EXCEL</Button>
            <Button onClick={printHandler} size="large"  color="secondary" startIcon={<MdPrint />}>PRINT</Button>
            
        </DialogActions>
    </Dialog>
  )
}
